<template>
  <v-card class="w-100" elevation="0">
    <div class="pa-2">
      <vue-table
        :data="transactionData"
        :headers="headers"
        :loading.sync="loading"
        :props="shallowProps"
        @change="onPagination"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row>
            <v-col cols="12" md="6" lg="3">
              <v-combobox
                :items="page"
                :label="`تعداد نمایش`"
                append-icon="mdi-chevron-down"
                dense
                outlined
                v-model="tableProps.length"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <v-combobox
                :items="services"
                v-model="tableProps.services"
                :label="`سرویس`"
                append-icon="mdi-chevron-down"
                dense
                outlined
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <commercial-qr-type v-model="props.selectQrType" />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <commercial-status-filter
                v-model="tableProps.selectActive.type"
                :count="tableProps.selectActive.count"
                :has-error="tableProps.selectActive.error"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <commercial-user-picker
                v-model="userpicker.users"
                :api-url="userpicker.apiUrl"
                :errors="userpicker.apiUrl"
                @confirm="onConfirmSelection"
                :id="qrland"
              />
            </v-col>
            <!-- <v-col cols="12" md="6" lg="3">
              <date-picker
                v-model="tableProps.time.start_time"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="از تاریخ"
              />
            </v-col> -->
            <!-- <v-col cols="12" md="6" lg="3">
    
              <date-picker
                v-model="tableProps.time.end_time"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="تا تاریخ"
              />
            </v-col> -->
            <v-col cols="12" md="6" lg="3">
              <v-text-field
                v-model="tableProps.discription"
                outlined
                dense
                append-icon="mdi-pencil"
                label="توضیحات"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <v-text-field
                v-model="tableProps.id"
                outlined
                dense
                append-icon="mdi-credit-card-settings-outline"
                label="شناسه تراکنش"
              />
            </v-col>
            <v-col cols="12">
              <v-btn class="btn-report my-0">ایجاد فاکتور</v-btn>
              <v-btn class="btn-buy my-0">حذف فیلتر </v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ transactionData.data.findIndex((data) => data.id == item.id) + 1 }}
        </template>
        <template v-slot:qrName="{ item }">
          {{ item.qrName }}
        </template>
        <template v-slot:price="{ item }">
          <v-btn
            color="#f28b82"
            class="white--text"
            elevation="0"
            width="100px"
          >
            {{ item.price.toLocaleString() }}
          </v-btn>
        </template>
        <template v-slot:name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:description="{ item }">
          {{ item.description }}
        </template>
        <template v-slot:type="{ item }">
          <v-btn
            color="#a0c8e8"
            class="white--text"
            elevation="0"
            width="100px"
          >
            {{ showType(item.type) }}
          </v-btn>
        </template>
        <template v-slot:pay_due_days="{ item }">
          {{ item.pay_due_days }}
        </template>
        <template v-slot:due_days="{ item }">
          {{ item.due_days }}
        </template>
        <template v-slot:payment_id="{ item }">
          {{ item.payment_id }}
        </template>
        <template v-slot:fine="{ item }">
          {{ item.fine }}
        </template>
        <template v-slot:status="{ item }">
          <!-- :class="item.status === 'pending' ? 'black--text' : 'white--text'" -->
          <v-btn
            class="white--text"
            elevation="0"
            width="35px"
            :color="showStatus(item.status).color"
          >
            {{ showStatus(item.status).text }}
          </v-btn>
        </template>
      </vue-table>
    </div>
  </v-card>
</template>
<script>
import TypeMenu from "../../../../pages/robot/autoCard/TypeMenu.vue";
import headerStatusFilter from "../../../../pages/list/components/headerStatusFilter.vue";
import commercialStatusFilter from "./commercialStatusFilter.vue";
import CommercialQrType from "./commercialQrType.vue";
import customDatePicker from "../../../../content/custom-date-picker.vue";
import userPicker from "../../../../../core/plugins/TitleRibbon/pages/pickers/userPicker.vue";
import commercialUserPicker from "./commercialUserPicker.vue";
import commercialListItemFive from "../../commercialListCo/commercialListItemFive.vue";
import commercialListItemFour from "../../commercialListCo/commercialListItemFour.vue";

import debounce from "lodash/debounce";
export default {
  components: {
    TypeMenu,
    headerStatusFilter,
    CommercialQrType,
    commercialStatusFilter,
    customDatePicker,
    userPicker,
    commercialUserPicker,
    commercialListItemFive,
    commercialListItemFour,
  },
  name: "commercialAdmin",
  props: {
    qrland: Number,
    value: [Object, Array, null],
    admin: Boolean,
  },

  watch: {
    // "tableProps.services": debounce(function (newVal) {
    //   this.fetch(this.tableProps);
    // }, 300),
    // "time.start_time": debounce(function (newVal) {
    //   this.fetch(this.tableProps);
    // }, 300),
    // "time.end_time": debounce(function (newVal) {
    //   this.fetch(this.tableProps);
    // }, 300),
  },

  mounted() {},

  computed: {
    shallowProps() {
      return this.tableProps;
    },
  },

  data() {
    return {
      page: ["10", "20", "30", "40", "50"],
      itemsType: [],
      actionType: false,
      selectQrType: "all",

      services: [
        { value: "rent", text: "اجاره" },
        { value: "charge", text: "شارژ" },
        { value: "banner", text: "رزرو بنر" },
        { value: "space", text: "رزرو فضا" },
      ],

      headers: [
        { text: "ردیف", value: "index", align: "center" },
        {
          text: "نام کیوآر",
          value: "qrName",
          align: "center",
          sortable: false,
        },
        { text: "نام", value: "name", align: "center" },
        { text: "توضیحات", value: "description", align: "center" },
        { text: "مبلغ", value: "price", align: "center" },
        { text: "نوع سرویس", value: "type", align: "center" },
        { text: "تاریخ پرداخت", value: "pay_due_days", align: "center" },
        { text: "موعد پرداخت", value: "due_days", align: "center" },
        { text: "شناسه پرداخت", value: "payment_id", align: "center" },
        { text: "جریمه", value: "fine", align: "center" },
        { text: "وضعیت", value: "status", align: "center" },
      ],
      transactionData: {
        data: [],

        total: 10,
        page: 1,
        per_page: 5,
      },
      userpicker: {
        users: [],
        apiUrl: "/api/user",
        errors: [],
      },
      loading: false,
      tableProps: {
        search: "",
        services: { value: "rent", text: "اجاره" },
        length: 10,
        productId: [],
        column: "id",
        dir: "desc",
        selectQrType: "all",
        page: 1,
        selectActive: {
          type: "all",
          count: 1,
          error: false,
        },

        time: {
          start_time: "",
          end_time: "",
        },
        id: "",
        discription: "",
      },
      tabis: [
        {
          text: "مدیریت نمایش",
          value: "show",
          icon: "view-grid-plus-outline",
        },
        {
          text: "مدیریت اجاره",
          value: "rent",
          icon: "cash-sync",
        },
      ],
      tabs: 0,
      action: false,
      shopSelect: {},
      infos: {},
    };
  },

  methods: {
    // تغییر موقت
    onPagination: debounce(function (e) {
      if (JSON.stringify(e) == JSON.stringify(this.tableProps)) {
        this.fetch(e);
      } else {
        this.loading = false;
      }
    }, 300),
    // تغییر موقت
    fetch(params) {
      // if (this.loading) return;

      this.loading = true;
      let filters = {
        page: params.page,
        length: params.length,
        sort: "desc",
        transaction: params.id,
        desc: params.discription,
        expired: params.selectActive.type,
        qr_type: params.selectQrType == "all" ? null : params.selectQrType,
      };
      let filterData = [];
      this.$api
        .get(`${this.$qrApi}/v1/commercial/orders/${this.qrland}`, {
          params: filters,
        })
        .then(({ data }) => {
          data.info.data.map((info) => {
            filterData.push({
              id: 6,
              qrName: info.qr_title,
              name: info.user.name,
              description: info.desc,
              type: info.type,
              pay_due_days: info.pay_date,
              due_days: info.due_date,
              payment_id: info.transaction_id,
              fine: info.penalty,
              status: info.pay_status,
              price: info.price,
            });
          });
        });
      this.transactionData = {
        data: filterData,

        total: 10,
        page: 1,
        per_page: 5,
      };
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    onConfirmSelection(e) {
      console.log("ok", this.userpicker);
    },
    showStatus(e) {
      switch (e) {
        case "pay":
          return { text: "پرداخت شده", color: "green" };
        case "unpaid":
          return { text: "پرداخت نشده", color: "red" };
        case "pending":
          return { text: "در انتظار تایید", color: "#ffd700" };
        default:
          return { text: "نامشخص", color: "primary" };
      }
    },
    showType(e) {
      switch (e) {
        case "rent":
          return "اجاره";
        case "charge":
          return "شارژ";
        case "banner":
          return "اجاره بنر";
        case "space":
          return "اجاره فضای تبلیغاتی";
        default:
          return "نامشخص";
      }
    },
  },
};
</script>

<style></style>
